// SPDX-License-Identifier: LicenseRef-Syncanix-Proprietary
import type { StatusIncident } from './Status';

/**
 * Live incidents first, then resolved ones, each half newest-first.
 *
 * The feed's own order is the writer's, and on the one page where "is this
 * still happening" is the question, an unresolved outage must never sit below
 * yesterday's completed maintenance because of how the JSON happened to be
 * assembled. Presentation, not content: nothing is filtered out.
 */
export function orderIncidents(incidents: readonly StatusIncident[]): readonly StatusIncident[] {
  const started = (incident: StatusIncident): number => Date.parse(incident.startedAt) || 0;
  return [...incidents].sort((a, b) => {
    const live = Number(a.resolvedAt !== undefined) - Number(b.resolvedAt !== undefined);
    return live !== 0 ? live : started(b) - started(a);
  });
}
